import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardList, FileText, Landmark, Megaphone, ShieldCheck } from 'lucide-react';
import { kindLabel } from '../../utils/assistantEntities';

const ICONS = {
  license: FileText,
  process: Landmark,
  complaint: Megaphone,
  condicionante: ClipboardList,
  enterprise: ShieldCheck,
};

const AssistantEntityCards = ({ entities }) => {
  if (!entities?.length) return null;

  return (
    <ul className="mt-3 space-y-2">
      {entities.map((item) => {
        const Icon = ICONS[item.kind] || FileText;
        return (
          <li
            key={`${item.kind}-${item.id || item.href}`}
            className="rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-soft"
          >
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start">
              <div className="flex min-w-0 flex-1 items-start gap-3">
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-800 ring-1 ring-primary-100">
                  <Icon className="h-4 w-4" aria-hidden />
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                    {kindLabel(item.kind)}
                  </p>
                  <p className="text-sm font-semibold text-slate-900">{item.title}</p>
                  {item.status || item.meta ? (
                    <p className="mt-0.5 text-xs text-slate-500">
                      {[item.status, item.meta].filter(Boolean).join(' · ')}
                    </p>
                  ) : null}
                </div>
              </div>
              <Link to={item.href} className="btn btn-primary btn-sm w-full shrink-0 sm:w-auto">
                {item.cta}
              </Link>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default AssistantEntityCards;
